module.exports = function(notifications) {
	'use strict'
	notifications.directive('allNotificationsDir',allNotificationsDir);
	allNotificationsDir.$inject=[];
	function allNotificationsDir() {
		return {
			template: require('./partial/allnotifications.html'),
			controller:'allNotificationsController',
			controllerAs:'vman',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/notificationsModule/allnotifications/js/directive/allnotificationsDirective.js
// module id = 531
// module chunks = 0